import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { Observer } from "mobx-react-lite";
import { useStores } from "@stores";

interface IProps extends RouteProps {}

const PrivateRoute: React.FC<IProps> = ({ children, ...rest }) => {
  const { accountStore } = useStores();
  return (
    <Route
      {...rest}
      render={({ location }) => (
        <Observer>
          {() =>
            // accountStore.user && accountStore.user.isAnonymous ? (
            !accountStore.user ? (
              <Redirect
                to={{ pathname: "/login", state: { from: location } }}
              />
            ) : (
              <React.Fragment>{children}</React.Fragment>
            )
          }
        </Observer>
      )}
    />
  );
};
export default PrivateRoute;
